var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-download"},[_c('button',{staticClass:"button-google-play",on:{"click":_vm.downloadGPlay}}),_c('button',{staticClass:"button-app-store",on:{"click":_vm.downloadAppStore}})])
}
var staticRenderFns = []

export { render, staticRenderFns }